import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { QueryQuestionAttemptsTrackingQuery, QueryQuestionAttemptsTrackingQueryPayload } from '../api'
import { QuestionAttemptsSuspendDataStore } from '../common';
import { QueryHandler } from '@/app/tracking/common';

const debug = Debug('scorm2004-query-question-attempts-query-handler')

@injectable()
export class Scorm2004QueryQuestionAttemptsQueryHandler implements QueryHandler<QueryQuestionAttemptsTrackingQuery> {

  constructor (
    @inject(QuestionAttemptsSuspendDataStore)
    private store: QuestionAttemptsSuspendDataStore,
  ) {}
  
  public async execute(query: QueryQuestionAttemptsTrackingQueryPayload) {

    debug('execute', query)

    const attempts = await this.store.query('all')

    debug('attempts', attempts)

    return attempts
  }
}
